'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.DemandTransparency.Toolbar', dependencies).directive('rmDemandTransparencyToolbar', require('./directives/DemandTransparencyToolbarDirective'));